import { ApiService } from '../../../services/api_service';
import { ContextService } from '../../../services/context_service';
import { ExcelTool } from '../../../core/excel/excel_tool';
import { FileUploadDialog } from '../../../core/fileupload/FileUploadDialog';
import { IDs } from '../../../helpers/IDs';
import { lazyInject } from '../../../services/inversify';
import * as React from 'react';
import { RechteService } from '../../../services/rechte_service';
import style from '../../../default.less';
import { WActionButton } from '../../../core/elements/WActionButton';
import { WSpinner } from '../../../core/elements/spinner/WSpinner';
import { WorkBook } from 'xlsx/types';
import { importKennzahlen } from './routinen/importKennzahlen';
import { processKennzahlen, processKennzahlenWerte } from './routinen/processKennzahlen';
import { DataService } from '../../../services/data_service';
import { TriggerService } from '../../../core/trigger/trigger_service';

interface KennzahlenImportProps extends React.ClassAttributes<any> {
    data: any;
}

interface KennzahlenImportState {
    aufnahmeData: any;
    gewerkSelected: number;
    situationSelected: string;
    sheetSelected: string;
    sheetList: Array<string>;
    workBook: WorkBook;
    isLoaded: boolean;
    module: string;
    showSpinner: boolean;
}

export class KennzahlenImport extends React.Component<KennzahlenImportProps, KennzahlenImportState> {

    constructor(props: any) {
        super(props);
        this.state = {
            aufnahmeData: undefined,
            isLoaded: false,
            gewerkSelected: undefined,
            situationSelected: 'taetigkeit_kunden_bausstelle',
            sheetList: undefined,
            sheetSelected: undefined,
            module: IDs.MOD_ETOOL_ADMIN,
            showSpinner: false,
            workBook: undefined
        };
        this.onDataLoaded = this.onDataLoaded.bind(this);
        this.importieren = this.importieren.bind(this);
    }

    @lazyInject(ApiService) private apiService: ApiService;
    @lazyInject(ContextService) private contextService: ContextService;
    @lazyInject(RechteService) private rechteService: RechteService;
    @lazyInject(DataService) private dataService: DataService;
    @lazyInject(TriggerService) private triggerService: TriggerService;

    render() {
        return (
            <div
                style={{ textAlign: 'center', padding: '20px' }}
            >
                <div className={style.infofield}>
                   Kennzahlen aus Excel importieren
                    <FileUploadDialog
                        onDataLoaded={this.onDataLoaded}
                        onDataSelected={() => this.setState({ showSpinner: true })}
                    />
                </div>
                {this.state.isLoaded && this.renderSheetSelect()}
                {this.state.isLoaded && this.renderGewerkeSelect()}
                {this.state.isLoaded && this.renderSituationSelect()}
                {this.state.isLoaded && this.renderButton()}
                {this.state.showSpinner && <WSpinner/>}
            </div>
        );
    }
    renderButton() {
        return <button
                disabled = {!this.state.sheetSelected || !this.state.gewerkSelected}
                onClick={this.importieren}
            > Importieren </button> ;
    }
    renderSheetSelect() {
        return <div>
            Tabellenblatt <br /><select
                value={this.state.sheetSelected}
                onChange = {(evt: any) => this.setState({sheetSelected: evt.target.value})}
            >
                {this.state.sheetList.map((s: string) =>
                    <option value={s}>{s}</option>
                )}
            </select>
        </div>;
    }
    renderGewerkeSelect() {
        console.log('DATA', this.props.data);
        const gewerke = this.props.data[IDs.ENT_BRANCHEN_GEWERKE];
        const gewerke_sort = gewerke.sort((a: any, b: any) => {
                if (a.name < b.name) { return -1; }
                if (a.name > b.name) { return 1; }
            return 0;
        });
        return <div>
            Gewerk <br /><select
                value={this.state.gewerkSelected}
                onChange = {(evt: any) => this.setState({gewerkSelected: +evt.target.value})}
            >
                {gewerke_sort.map((g: any) =>
                    <option value={g.tid}>{g.name}</option>
                )}
            </select>
        </div>;
    }
    renderSituationSelect() {
        return <div>
        Betriebliche Situation <br /><select
            value={this.state.situationSelected}
            onChange = {(evt: any) => this.setState({situationSelected: evt.target.value})}
        >
          <option value={'taetigkeit_kunden_bausstelle'}>Tätigkeit überwiegend bei Kunden / auf Baustelle</option>
          <option value={'taetigkeit_ladengeschaeft'}>Tätigkeit überwiegend in einem Ladengeschäft</option>
          <option value={'taetigkeit_werkstatt_produktionsstaette'}>Tätigkeit überwiegend in einer Werkstatt oder Produktionsstätte</option>
        </select>
        </div>;
    }

    importieren() {
        const excel = new ExcelTool();
        const result = importKennzahlen(excel, this.state.workBook, this.state.sheetSelected);
        const data_kz = processKennzahlen(this.props.data, result, this.state.gewerkSelected, this.state.situationSelected);
        const data_werte = processKennzahlenWerte(this.props.data, result, this.state.gewerkSelected, this.state.situationSelected);

        // console.log('KZD_SAVE: ', data_kz);
        this.dataService.saveDataList(IDs.ENT_KENNZAHLEN_DEFINTION, data_kz, () => {
            this.triggerService.fire('reload', IDs.ENT_KENNZAHLEN_DEFINTION);   // Reload triggern
            this.dataService.saveDataList(IDs.ENT_KENNZAHLEN_WERTE_ZENTRAL, data_werte, () => {
                alert('Daten wurden gespeichewrt');
                this.triggerService.fire('reload', IDs.ENT_KENNZAHLEN_WERTE_ZENTRAL);   // Reload triggern
            }, IDs.MOD_ETOOL_ADMIN);

        }, IDs.MOD_ETOOL_ADMIN);
    }

    private async onDataLoaded(dataLoaded: string) {
        // Excel-Datei zunächst mit XLSX parsen
        const start = new Date().getTime();
        const excel = new ExcelTool();
        const workBook = excel.getWorkbook(dataLoaded);
        const sheetList = workBook.SheetNames;
        // console.log('Workbook loaded after ' + (new Date().getTime() - start));
        // tslint:disable-next-line: max-line-length
        // console.log('Data extracted after ' + (new Date().getTime() - start));
        const { data } = this.props;
        this.setState({
            workBook,
            isLoaded: true,
            showSpinner: false,
            sheetList
        });
    }
}
